import React from "react";
import "./panchangam.css";
import { Box, Grid, Typography } from "@mui/material";
import TitleBox from "../../../../components/common/titleBox/TitleBox";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

function PanchangamSVT(props) {
  const { dailyPanchang } = props;
  return (
    <TitleBox
      title={
        <Box class="panchang-title">
          <Typography variant="h6" component="div">
            Panchang
          </Typography>
        </Box>
      }
      buttonLabel={"Alamnac"}
      buttonLink={"/fullpanchang"}
      content={
        <>
          <React.Fragment>
            <Grid className="panchang">
              <Grid >
                <Grid className="pancgan-table">
                  <Grid className="row">
                    {dailyPanchang ? (
                      <>
                        <Grid container d-flex justifyContent={"space-between"}>
                          <Grid item xs={6}>
                            {" "}
                            <h4 class="news">
                             <CalendarMonthIcon fontSize="small" />
                              Panchangam
                              <br />
                              <span style={{ "font-size": "14px" }}>
                                (Pittsburgh, USA Time)
                              </span>
                            </h4>
                          </Grid>
                          <Grid item xs={5}>
                            <p
                             
                            >
                              {new Date().toLocaleDateString("en-US", {
                                timeZone: "America/New_York",
                                weekday: "long",
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              })}
                            </p>
                          </Grid>
                        </Grid>

                        <Grid container d-flex justifyContent={"space-between"}>
                          <Grid item xs={5}>
                            <ul className="list-2">
                              <li>
                                Tithi :
                                <span>
                                  {!dailyPanchang.tithi1_name &&
                                  !dailyPanchang.tithi1_time &&
                                  !dailyPanchang.tithi2_name &&
                                  !dailyPanchang.tithi2_time ? (
                                    "-"
                                  ) : (
                                    <>
                                      {dailyPanchang.tithi1_name &&
                                        dailyPanchang.tithi1_time &&
                                        `${dailyPanchang.tithi1_name} till ${dailyPanchang.tithi1_time}`}
                                      {dailyPanchang.tithi1_name &&
                                        !dailyPanchang.tithi1_time &&
                                        dailyPanchang.tithi1_name}
                                      {dailyPanchang.tithi2_name &&
                                        dailyPanchang.tithi2_time &&
                                        ` ${dailyPanchang.tithi2_name} till ${dailyPanchang.tithi2_time}`}
                                      {dailyPanchang.tithi2_name &&
                                        !dailyPanchang.tithi2_time &&
                                        dailyPanchang.tithi2_name}
                                    </>
                                  )}
                                </span>
                              </li>
                              <li>
                                Yoga :
                                <span>
                                  {dailyPanchang.yoga_name
                                    ? `${dailyPanchang.yoga_name} ${
                                        dailyPanchang.yoga_time
                                          ? `till ${dailyPanchang.yoga_time}`
                                          : ""
                                      }`
                                    : "-"}
                                </span>
                              </li>
                              <li>
                                Yamagandam :
                                <span>
                                  {dailyPanchang.yamaganda_begin &&
                                  dailyPanchang.yamaganda_end
                                    ? `${dailyPanchang.yamaganda_begin} - ${dailyPanchang.yamaganda_end}`
                                    : "-"}
                                </span>
                              </li>
                              <li>
                                Varjyam :
                                <span>
                                  {!dailyPanchang.varjya1_begin &&
                                  !dailyPanchang.varjya1_end &&
                                  !dailyPanchang.varjya2_begin &&
                                  !dailyPanchang.varjya2_end ? (
                                    "-"
                                  ) : (
                                    <>
                                      {dailyPanchang.varjya1_begin &&
                                        dailyPanchang.varjya1_end &&
                                        `${dailyPanchang.varjya1_begin} - ${dailyPanchang.varjya1_end}`}
                                      {dailyPanchang.varjya1_begin &&
                                        !dailyPanchang.varjya1_end &&
                                        dailyPanchang.varjya1_begin}
                                      {dailyPanchang.varjya2_begin &&
                                        dailyPanchang.varjya2_end &&
                                        ` ${dailyPanchang.varjya2_begin} - ${dailyPanchang.varjya2_end}`}
                                      {dailyPanchang.varjya2_begin &&
                                        !dailyPanchang.varjya2_end &&
                                        dailyPanchang.varjya2_begin}
                                    </>
                                  )}
                                </span>
                              </li>
                            </ul>
                          </Grid>
                          <Grid item xs={5}>
                            <ul className="list-2">
                              <li>
                                Nakshatra :
                                <span>
                                  {!dailyPanchang.nakshatram1_name &&
                                  !dailyPanchang.nakshatram1_time &&
                                  !dailyPanchang.nakshatram2_name &&
                                  !dailyPanchang.nakshatram2_time ? (
                                    "-"
                                  ) : (
                                    <>
                                      {dailyPanchang.nakshatram1_name &&
                                        dailyPanchang.nakshatram1_time &&
                                        `${dailyPanchang.nakshatram1_name} till ${dailyPanchang.nakshatram1_time}`}
                                      {dailyPanchang.nakshatram1_name &&
                                        !dailyPanchang.nakshatram1_time &&
                                        dailyPanchang.nakshatram1_name}
                                      {dailyPanchang.nakshatram2_name &&
                                        dailyPanchang.nakshatram2_time &&
                                        ` ${dailyPanchang.nakshatram2_name} till ${dailyPanchang.nakshatram2_time}`}
                                      {dailyPanchang.nakshatram2_name &&
                                        !dailyPanchang.nakshatram2_time &&
                                        dailyPanchang.nakshatram2_name}
                                    </>
                                  )}
                                </span>
                              </li>
                              <li>
                                Rahukalam :
                                <span>
                                  {dailyPanchang.rahukala_begin &&
                                  dailyPanchang.rahukala_end
                                    ? `${dailyPanchang.rahukala_begin} - ${dailyPanchang.rahukala_end}`
                                    : "-"}
                                </span>
                              </li>
                              <li>
                                <span>
                                  <img
                                    className="sun-img"
                                    src={process.env.REACT_APP_S3_BASE_URL + "/api/images/sunrise.png"}
                                    alt="Sunrise"
                                  />{" "}
                                  {dailyPanchang.sunrise}
                                </span>
                                <span>
                                  <img
                                    className="sun-img"
                                    src={process.env.REACT_APP_S3_BASE_URL + "/api/images/sunset.png"}
                                    alt="Sunset"
                                  />
                                  {dailyPanchang.sunset}
                                </span>
                              </li>
                            </ul>
                          </Grid>
                        </Grid>
                      </>
                    ) : (
                      <Grid className="no-data">No Panchang data available</Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </React.Fragment>
        </>
      }
    />
  );
}
export default PanchangamSVT;
